import { useAuth } from '../../contexts/auth';

const ShowFor = ({ roles = [], permissions = [], children }) => {
  // return children;
  const { user, hasRole, hasPermission } = useAuth();

  if (!user) return null;
  if (roles.length && !hasRole(roles)) return null;
  if (permissions.length && !hasPermission(permissions)) return null;

  return children;
};

export default ShowFor;
